import React from 'react';
import moment from 'moment';
import {
    Paper,
    List, ListItem, ListItemText, ListItemIcon,
    Typography, Divider
} from '@mui/material';
import Icon from '@mdi/react'
import {
    mdiMapMarker, mdiSpeedometer, mdiCalendarClock
} from '@mdi/js';
import eventIcons from '../../../utils/eventIcons.js';



const GoogleEventDetailCard = ({ eventData }) => {
    const { regn, event_desc, event_time, address, speed } = eventData;

    return (

        <Paper style={{ width: '300px' }}>
            <List dense>
                <ListItem>
                    <ListItemText
                        primary={
                            <Typography variant="h6">{regn}</Typography>
                        }
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        {eventIcons(eventData.event_desc)}
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography variant="body1"><b>{event_desc}</b></Typography>
                        }
                    />
                </ListItem>
                <Divider />
                {
                    address ?
                        <ListItem>
                            <ListItemIcon>
                                <Icon path={mdiMapMarker} size={1} color="DodgerBlue" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body1"><b>Location</b></Typography>
                                }
                                secondary={
                                    <Typography variant="body1" display="inline">{address.Location}</Typography>
                                }
                            />
                        </ListItem>
                        : <ListItem></ListItem>
                }

                {
                    speed ?

                        <ListItem>
                            <ListItemIcon>
                                <Icon path={mdiSpeedometer} size={1} color="DodgerBlue" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body1"><b>Speed</b></Typography>
                                }
                                secondary={
                                    <Typography variant="body1" display="inline">{`${speed} Km/h`}</Typography>
                                }
                            />
                        </ListItem>
                        : <ListItem></ListItem>
                }
                <ListItem>
                    <ListItemIcon>
                        <Icon path={mdiCalendarClock} size={1} color="DodgerBlue" />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography variant="body1"><b>Time</b></Typography>
                        }
                        secondary={
                            <Typography variant="body1" display="inline">{moment(event_time).format('Do MMM YY hh:mm:ss A')}</Typography>
                        }
                    />
                </ListItem>

            </List>
        </Paper>
    );


}

export default GoogleEventDetailCard;